module.exports = __webpack_public_path__ + "img/1505910163.b823bca6.jpg";